import { View } from '@adobe/react-spectrum';
import InfoMedium from '@spectrum-icons/ui/InfoMedium';
import Close from '@spectrum-icons/workflow/Close';
import { useDispatch, useSelector } from 'react-redux';
import { setCaliforniaToastClosed } from '../../../../redux/actions/contactCenterActions';
import { CALLEVENTS } from '../../../ContactCenter/Constants';
import { ContactRecord as iContactRecord } from '../../../ContactCenter/Models';
import './californiaToast.scss';

interface State {
  contactCenter: {
    currentConversation: iContactRecord
    californiaToastFlag: { [key: string]: boolean }
    californiaToastClosed: { [key: string]: boolean }
  }
}

const BANNER_TEXT = `California based customer. Give customer assurance of cancellation before pitching any save offers. Use 'California Cancel' PDC.`
const CaliforniaToast = () => {
  const dispatch = useDispatch()

  const { currentConversation, californiaToastFlag, californiaToastClosed } = useSelector((state: State) => state.contactCenter)
  const {
    ocPlatformData: {
      chatInfo: { currentContactId = '', status = '' } = {},
      callInfo: { status: callStatus = '', origin = '' } = {}
    } = {}
  } = currentConversation || {}

  const handleCloseToast = (e: React.MouseEvent<HTMLDivElement>) => {
    e.stopPropagation();
    dispatch(setCaliforniaToastClosed(currentContactId, true))
  }

  const isInteractionOpen = (origin === CALLEVENTS.CHAT_TO_PHONE && callStatus !== 'Closed') || status !== 'Closed'

  if (currentContactId && californiaToastFlag[currentContactId] && !californiaToastClosed[currentContactId] && isInteractionOpen) {
    return (
    <View UNSAFE_className="oac-california-toast">
        <div className="california-toast-content">
              <InfoMedium />
              <div className="california-toast-text">
                <span>{BANNER_TEXT}</span>
              </div>
            <div className="california-toast-close-icon">
                <div className="california-toast-action-button" onClick={handleCloseToast}>
                    <Close size="S" />
                </div>
            </div>
        </div>
    </View>
    )
  }
  return <></>
}

export default CaliforniaToast 